import Swiper, { Scrollbar } from 'swiper';

Swiper.use([Scrollbar]);

const selectors = {
  swiper: '.js-reference-swiper',
  scrollbar: '.js-recipes-swiper-scrollbar',
};

const referenceSlider = () => {
  const container = document.querySelector(selectors.swiper);
  if (container === null) return;

  const swiper = new Swiper(selectors.swiper, {
    slidesPerView: 'auto',
    spaceBetween: 20,
    scrollbar: {
      el: selectors.scrollbar,
      draggable: true,
    },
    breakpoints: {
      1024: {
        spaceBetween: 150,
      },
    },
  });
};

export default referenceSlider;
